var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground}},[_c('div',{staticClass:"logo-home"},[_c('img',{attrs:{"src":_vm.appLogo}})]),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Accueil',
          icon: 'ni ni ni-shop text-gray',
          path: '/menu',
        }}}),(_vm.hasAccessAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Tableau de bord',
          icon: 'ni ni-tv-2 text-gray',
          path: '/dashboard',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Utilisateurs',
          icon: 'ni ni-circle-08 text-gray',
          path: '/tablesuser',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Clients',
          icon: 'ni ni-circle-08 text-gray',
          path: '/tablesclient',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Articles',
          icon: 'ni ni-ungroup text-gray',
          path: '/listeproduit',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Caisse',
          icon: 'ni ni-ungroup text-gray',
          path: '/caisse/' + _vm.getDefaultClient(),
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Historique Caisse',
          icon: 'ni ni-ungroup text-gray',
          path: '/caissehistory',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Retours',
          icon: 'ni ni ni-archive-2 text-gray',
          path: '/retours',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Paiements',
          icon: 'ni ni ni-archive-2 text-gray',
          path: '/payments',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Historique',
          icon: 'ni ni ni-archive-2 text-gray',
          path: '/historique',
        }}}),(_vm.hasAccessAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Corbeille',
          icon: 'ni ni ni-archive-2 text-gray',
          path: '/listeproduitarchive',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Paramètrage produit',
          icon: 'ni ni-tv-2 text-gray',
          path: '/sp',
        }}}),(_vm.hasAccessAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Paramètrage',
          icon: 'ni ni-tv-2 text-gray',
          path: '/appsettings',
        }}}):_vm._e(),_c('div',{on:{"click":function($event){return _vm.logout()}}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Se déconnecter',
            icon: 'ni ni ni-button-power text-gray',
            path: '#',
          }}})],1),_c('div',{staticStyle:{"position":"fixed","bottom":"10px","left":"30px","font-size":"15px","font-weight":"bold"}},[_vm._v("\n        2024 © Ntech \n      ")])],1)],2),_c('div',{staticClass:"main-content",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('div',{on:{"click":_vm.toggleSidebar}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1),_c('div',{staticClass:"search-prod"},[_c('SearchProduct',{ref:"lookForProduct"})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }